import styled, { ThemeProps } from 'styled-components';

// import {Theme} from '../../../../../theme/types';

export const AutocompleteWrapperStyles = styled.div(
  props => `
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`
);

export const SearchInputStyles = styled.input(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.dark};
  color: white;
  border: none;
  font-size: ${props.theme.font.custom(16)};
  
  font-weight: 500;
  text-transform: capitalize;

  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.custom(
    12
  )} ${props.theme.spacing.base};
    line-height: 1.3;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    flex-direction: row;
    align-items: center;
    justify-conent: center;
    &::-webkit-input-placeholder{
      color: white;
      opacity: 0.5;
      ${SearchInputStyles}.font-size;
      ${SearchInputStyles}.font-family;
      ${SearchInputStyles}.font-weight;
    }
    &:focus{
      box-shadow: none;
      outline: none;
    }
`
);

export const SearchLabelStyles = styled.label(
  props => `
  color: ${props.theme.colors.goWhite.base};
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
  opacity: 0.6;
`
);

export const SuggstEleContain = styled.div`
  ${props => props.theme.flexCol};
  ${props => props.theme.flex1};
  padding-left: ${props => props.theme.spacing.custom(10)};
  /* padding-bottom: ${props => props.theme.spacing.custom(10)}; */
`;

export const SuggstEleHd = styled.div`
  color: #000000;
  font-size: ${props => props.theme.font.custom(15)};
  padding-bottom: ${props => props.theme.spacing.custom(5)};
`;

export const SuggstEleSubHdWrp = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.justifyStart};
`;

export const SuggstEleSubHd = styled.div`
  color: #767676;
  font-size: ${props => props.theme.font.custom(15)};
  padding-left: ${props => props.theme.spacing.small};
`;

export const SuggestEleDesc = styled.div`
  color: #767676;
  font-size: ${props => props.theme.font.custom(12)};
`;

export const SearchListItem = styled.li(
  props => `
  display: flex;
  align-items: center;
  border-top: 1px solid ${props.theme.colors.downriver.light};
  padding: ${props.theme.spacing.base};
  font-size: ${props.theme.font.custom(16)};
  background: ${
    // @ts-ignore
    props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
  }
  &:first-child{
    border-top:none;
  }
  cursor: pointer;
`
);

export const SearchMenuStyles = styled.ul`
  z-index: ${props => props.theme.misc.zIndex.xxlarge};
  position: absolute;
  /* top: ${props => props.top || '4rem'}; */
  /* left: ${props => props.left || '-2rem'}; */
  /* left: ${props => -props.theme.spacing.xlarge}; */
  list-style-type: none;
  background: ${props => props.theme.colors.goWhite.base};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  transform: translateY(4px);
  min-width: 27rem; /** zepline has 746px, change to it if need*/
  max-height: ${props => (props.maxHeight ? props.maxHeight : '90vh')};
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }
`;
